import {
  ITicketPostInterface,
  ITicketPostAddViewModel,
  ITicketViewModel,
  ITicketDetailsInterface,
} from 'Interfaces/ITicketConfig';
import { ConvertToAttachment } from './ConvertToAttachment';
import { GetWorkRole } from './GetWorkRole';
import dayjs from 'dayjs';
import { calculateTicketPostBilling } from './calculateTicketPostBilling';
import { mergeEmailSources } from './mergeEmailSources';

export const ConvertToTicketPost = (
  ticketPost: ITicketPostInterface,
  ticket: ITicketViewModel | ITicketDetailsInterface,
  user: any
) => {
  console.log('calculateTicketPostBilling: ConvertToTicketPost', ticketPost);
 // 1. Bygg toEmail / ccEmail av ticketPost.ticketPost.toEmailList
  const toEmail = mergeEmailSources(
    ticketPost.ticketPost.toEmailList,
  );

  const ccEmail = mergeEmailSources(
    ticketPost.ticketPost.ccEmailList,
  );
   // 2. Resten av objektet 
  let _ticketPost: ITicketPostAddViewModel = {
    ticketId: ticket.id,
    status: ticketPost.ticketPost.status,
    startTime: dayjs(ticketPost.ticketPost.startTime), // Send local time, no UTC conversion
    endTime: dayjs(ticketPost.ticketPost.endTime), // Send local time, no UTC conversion
    startDeduction: null, // Send local time
    endDeduction: null, // Send local time
    toEmail: toEmail || '', // Send toEmail, no UTC conversion
    ccEmail: ccEmail || '', // Send ccEmail, no UTC conversion
    isBillable: ticketPost.ticketPost.isBillable,
    isOvertime: ticketPost.ticketPost.isOvertime, // Send Overtime, no UTC conversion conversionoverTime,
    isBilled: false,
    internal: ticketPost.ticketPost.internal,
    isInHouse: ticketPost.ticketPost.isInHouse,
    isEmailSent: ticketPost.ticketPost.isEmailSent,
    direction: 1,
    authorId: user.id,
    receiverId: ticketPost.ticket?.contact.id ?? '',
    changedById: null,
    message: ticketPost.ticketPost.message || '',
    originalMessage: ticketPost.ticketPost.originalMessage || '',
    attachments: ticketPost.ticketPost.attachments
      ? ConvertToAttachment(ticketPost.ticketPost.attachments)
      : null,
    workRoleId: ticketPost.ticketPost.workRole?.id
      ? ticketPost.ticketPost.workRole?.id
      : null,
    ticketPostBilling: calculateTicketPostBilling(ticketPost, ticket),
    isCCSent: ticketPost.ticketPost.isCCSent,
    isApp: false,
  };
  console.log(
    'calculateTicketPostBilling: ConvertToTicketPost ++',
    _ticketPost
  );

  return _ticketPost;
};
